<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiPaletteSwatchOutline" />
      Existing Tools
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Tools"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="tool of tools" :key="tool" class="grey--text caption mb-1">{{ tool }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiPaletteSwatchOutline, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'toolList',
  data() {
    return {
      mdiPaletteSwatchOutline,
      mdiMagnify,
      search: '',
      tools: []
    }
  },
  computed: {
    ...mapGetters([
      'toolOptions'
    ])
  },
  mounted() {
    this.tools = this.toolOptions.map((tool) => tool.name);
  },
  methods: {
    searchExisting() {
      this.tools = this.toolOptions.map((tool) => tool.name);
      if (this.search !== '') {
        this.tools = this.tools.filter((tool) => {
          const s = this.search.toLowerCase();
          return tool.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
